<template>
  <v-dialog
    v-model="computedDialogUiHelp"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile three-line>
      <v-toolbar card>
        <v-btn icon @click.native="methodDialogUi('help')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Help</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Logging in/User permissions</v-list-tile-title>
              <v-list-tile-sub-title>
                If you have any issues logging in or with user permissions,
                please contact Heather Dufty.
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title
                >Using {{ this.computedTitle }}</v-list-tile-title
              >
              <v-list-tile-sub-title
                >Please contact Heather Dufty.</v-list-tile-sub-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Submit a bug report</v-list-tile-title>
              <v-list-tile-sub-title>
                Please describe in detail what you were doing, what happened and
                what the expected outcome was.
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title>
                <v-btn @click="clearStorage()">Clear storage</v-btn>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title
                >Current role: {{ computedAuthProfile }}</v-list-tile-sub-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    computedDialogUiHelp() {
      return this.$store.state.ui.dialogs.help;
    },
    computedTitle() {
      return this.$store.state.general.title;
    }
  },
  methods: {
    methodDialogUi(dialog) {
      this.$store.commit("mutationDialogUi", {
        dialog: dialog
      });
    },
    clearStorage() {
      window.localStorage.removeItem("vuex");
      window.localStorage.removeItem("geowb");
      window.localStorage.removeItem("geowb-v1");
      window.localStorage.removeItem("geowb-v2");
      window.localStorage.removeItem("geowb-v3");
      window.location.reload(true);
    }
  }
};
</script>
